import * as React from "react";
import { Component } from "react";
import { connect } from "react-redux";

import {
  fetchOrdersfromChemist,
  fetchUrgentOrders,
  pageSelected,
  supportTickets,
  processednormalOrdersList,
  deliverednormalOrdersList,
  processedurgentOrdersList,
  deliveredurgentOrdersList,
  orderReturnList,
  fetchCreditNotes,
  cancellednormalOrdersList,
  cancelledurgentOrdersList,
} from "./action";

import Dashboard from "../../screens/Dashboard";

class DashboardContainer extends Component {
  render() {
    return (
      <Dashboard
        fetchOrdersfromChemist={this.props.fetchOrdersfromChemist}
        processednormalOrdersList={this.props.processednormalOrdersList}
        deliverednormalOrdersList={this.props.deliverednormalOrdersList}
        fetchUrgentOrders={this.props.fetchUrgentOrders}
        processedurgentOrdersList={this.props.processedurgentOrdersList}
        deliveredurgentOrdersList={this.props.deliveredurgentOrdersList}
        orderReturnList={this.props.orderReturnList}
        fetchCreditNotes={this.props.fetchCreditNotes}
        supportTickets={this.props.supportTickets}
        cancellednormalOrdersList={this.props.cancellednormalOrdersList}
        newnormalOrdersListCount={this.props.newnormalOrdersListCount}
        processednormalOrdersListCount={
          this.props.processednormalOrdersListCount
        }
        deliverednormalOrdersListCount={
          this.props.deliverednormalOrdersListCount
        }
        urgentOrders={this.props.urgentOrders}
        urgentOrdersCount={this.props.urgentOrdersCount}
        processedurgentOrdersListCount={
          this.props.processedurgentOrdersListCount
        }
        deliveredurgentOrdersListCount={
          this.props.deliveredurgentOrdersListCount
        }
        cancelledurgentOrdersList={this.props.cancelledurgentOrdersList}
        orderReturnListCount={this.props.orderReturnListCount}
        creditNotesCount={this.props.creditNotesCount}
        supportTicketsListCount={this.props.supportTicketsListCount}
        pageSelected={this.props.pageSelected}
        cancellnormalOrdersListCount={this.props.cancellnormalOrdersListCount}
        cancellurgentOrdersListCount={this.props.cancellurgentOrdersListCount}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchOrdersfromChemist: () => {
      dispatch(fetchOrdersfromChemist());
    },
    processednormalOrdersList: () => {
      dispatch(processednormalOrdersList());
    },
    deliverednormalOrdersList: () => {
      dispatch(deliverednormalOrdersList());
    },
    fetchUrgentOrders: value => {
      dispatch(fetchUrgentOrders(value));
    },
    processedurgentOrdersList: () => {
      dispatch(processedurgentOrdersList());
    },
    deliveredurgentOrdersList: () => {
      dispatch(deliveredurgentOrdersList());
    },
    orderReturnList: () => {
      dispatch(orderReturnList());
    },
    fetchCreditNotes: () => {
      dispatch(fetchCreditNotes());
    },
    supportTickets: () => {
      dispatch(supportTickets());
    },
    pageSelected: value => {
      dispatch(pageSelected(value));
    },
    cancellednormalOrdersList: () => {
      dispatch(cancellednormalOrdersList());
    },
    cancelledurgentOrdersList: () => {
      dispatch(cancelledurgentOrdersList());
    },
  };
}

const mapStateToProps = state => {
  return {
    newnormalOrdersListCount: state.DashboardReducer.newnormalOrdersListCount,
    processednormalOrdersListCount:
      state.DashboardReducer.processednormalOrdersListCount,
    deliverednormalOrdersListCount:
      state.DashboardReducer.deliverednormalOrdersListCount,
    urgentOrders: state.DashboardReducer.urgentOrders,
    urgentOrdersCount: state.DashboardReducer.urgentOrdersCount,
    processedurgentOrdersListCount:
      state.DashboardReducer.processedurgentOrdersListCount,
    deliveredurgentOrdersListCount:
      state.DashboardReducer.deliveredurgentOrdersListCount,
    orderReturnListCount: state.DashboardReducer.orderReturnListCount,
    creditNotesCount: state.DashboardReducer.creditNotesCount,
    supportTicketsListCount: state.DashboardReducer.supportTicketsListCount,
    cancellnormalOrdersListCount:
      state.DashboardReducer.cancellnormalOrdersListCount,
    cancellurgentOrdersListCount:
      state.DashboardReducer.cancellurgentOrdersListCount,
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(DashboardContainer);
